
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar2 from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";

import styled from 'styled-components';
import { BrowserRouter as Router, Route, Routes  } from "react-router-dom";
import LoginCom from './LoginCom';
import CCTVCom from './CCTVCom';

import HowToCom from './HowToCom';
import HowToCom2 from './HowToCom2';

import PrivacyCom from './PrivacyCom';
import ContactCom from './ContactCom';

import LiveCom from './LiveCom';
import LiveCom2 from './LiveCom2';

import DownloadCom from './DownloadCom';
import FeaturesCom from './FeaturesCom';
import WorldWideCCTVCom from './WorldWideCCTVCom';
import AdComponent from './AdComponent';
import {
  ScrollView
} from 'react-native';
import LeafletCom from './LeafletCOm';

// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";

const Nav = styled.nav`
    height : 100px;
    background-color : skyblue;
`

const Main = styled.main`
    display: flex;
`

const SideMenu = styled.div`
    min-width : 300px;
    min-height : 400px;
    border : 1px solid grey;
`




class Content extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }
  


  render() {
    return (
      <ScrollView>
        
      <Container fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
        <NavBar2 toggle={this.props.toggle} />

        

        <Router>
        
          <Routes>

            <Route exact path="/Login" element={<LoginCom />} />
            <Route path="/download" element={<DownloadCom />} />

            <Route path="/live" element={<LiveCom />} />
            
            <Route path="/live2" element={<LeafletCom />} />

            <Route path="/live3" element={<LiveCom2 />} />

            <Route path="/features" element={<FeaturesCom />} />
            <Route path="/howto" element={<HowToCom />} />
            <Route path="/howtoevent" element={<HowToCom2 />} />
            <Route path="/cctv" element={<CCTVCom />} />
            <Route path={"*"} element={<LoginCom />} />
            <Route path={"/privacy3"} element={<PrivacyCom />} />
            <Route path={"/contact"} element={<ContactCom />} />

            <Route path={"/worldwide"} element={<WorldWideCCTVCom />} />
          </Routes>
        </Router>
      <AdComponent></AdComponent>
      
      </Container>
      </ScrollView>
      
    );
  }
}




export default Content;
